import { Component, EventEmitter, Input, OnInit, Output, Pipe, PipeTransform } from '@angular/core';
import { SharedService } from '../../../shared/shared.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { PaymentusService } from '../paymentus.service';
import { DashboardService } from '../../../dashboard/dashboard.service';
import { LoggerService } from '../../../logger/logger.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FormControl, Validators } from '@angular/forms';

declare var $: any;

const ZIPCODE_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;
const DATE_REGEX = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/;
const CVV_REGEX = /^[0-9]{3,4}$/;
const MINIMUM_PAYMENT_WITHOUT_CHARGES: number = 60;

export interface PaymentMethod {
	id: number;
}

interface PaymentProfile {
	token: string;
	type: any;
	accountNumber: string;
	bankName: string;
	cardHolderName: string;
	default: boolean;
	creditCardExpiryDate: any;
	profileDescription: string;
	status: string;
	zip: string;
	active: string;
}

interface PaymentAmount {
	amount: number | string;
}

@Component({
	selector: 'app-submit-payment',
	templateUrl: './submit-payment.component.html',
	styleUrls: ['./submit-payment.component.css']
})
export class SubmitPaymentComponent implements OnInit {
	isLoading = false;
	@Input() isRecharge = false;
	@Input() isEnrollment = false;
	isExpressPay = false;
	@Input() displayBackButton = false;
	@Input() displayPaymentAmountOptions = false;
	paymentProfiles: PaymentProfile[] = [];
	primaryPaymentProfileId: number;
	primaryPaymentProfile: PaymentProfile;
	ipAddress: string = undefined;
	paymentAmount: number;
	currentAccountBalance: number;
	currentPaymentAmount = 0;
	cvv: string = undefined;
	isSettingCustomPaymentAmount = false;
	validCvv = false;
	isChangingPaymentMethod = false;
	@Input() billingAccountNumber: string;
	validPaymentAmount = true;
	processingFee: number = 5;
	savePaymentMethodToProfile = true;
	@Input() isAutoPay = false;
	paymentAmounts: PaymentAmount[] = [
		{ amount: 20 },
		{ amount: 60 },
		{ amount: 100 },
		{ amount: 'other' }
	];
	enrollmentAmounts: PaymentAmount[] = [
		{ amount: 60 },
		{ amount: 'other' },
	]
	paymentAmountControl = new FormControl('', [Validators.max(300), Validators.min(1)])
	ccvFormControl = new FormControl('', [
		Validators.required,
		Validators.minLength(3),
		Validators.maxLength(4),
		Validators.pattern(CVV_REGEX)]);
	isPaymentSuccess = false;
	isRetryPayment = true;
	paymentReceipt: any = {
		status: 'fail'
	};
	isSubmittingPayment = false;
	isSignedIn = false;
	public isAddingNewPaymentMethod = false;
	@Output('onPaymentMethodRefresh') onPaymentMethodRefresh: EventEmitter<any> = new EventEmitter<any>();
	@Output('onAmountChanged') onPaymentAmountChanged: EventEmitter<any> = new EventEmitter<any>();
	@Output('onBackButtonPressed') onBackButtonPressed: EventEmitter<any> = new EventEmitter<any>();
	@Output('onPaymentStatusUpdate') onPaymentStatusUpdate: EventEmitter<any> = new EventEmitter<any>();
	@Output('onSavePaymentProfileUpdate') onSavePaymentProfileUpdate: EventEmitter<any> = new EventEmitter<any>();
	@Output('onCvvUpdate') onCvvUpdate: EventEmitter<any> = new EventEmitter<any>();
	constructor(
		private sharedService: SharedService,
		private router: Router,
		private paymentusService: PaymentusService,
		private localStorageService: LocalStorageService,
		private activatedRoute: ActivatedRoute,
		private dashboardService: DashboardService,
		private logger: LoggerService,
	) {
		this.activatedRoute.params.subscribe((params: Params) => {
			this.paymentAmount = params['amount'];
		});
	}

	ngOnInit() {
		this.isLoading = true;
		this.currentPaymentAmount = MINIMUM_PAYMENT_WITHOUT_CHARGES;
		this.onPaymentAmountChanged.emit(this.currentPaymentAmount);
		this.sharedService.setHeaderErrorMessage('submit_payment', false, 'notification error', '');

		this.isExpressPay = this.localStorageService.get('is_express_pay')
		this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
			.then((res) => {
				if (res.status === 'success' && res.isTerminated === false) {
					const person = res.results[0]['personal'][0];
					this.isSignedIn = true;
					this.sharedService.setHeaderUserLoggedIn('submit_payment', true, person);
				}
			})

		this.sharedService.getIpAddress().then((resp) => {
			this.ipAddress = resp.ip;
		}).catch((err) => {
		});

		let token: string = this.localStorageService.get('token');
		if (token === null) {
			token = this.localStorageService.get('tempToken');
		}
		if (token && !this.isExpressPay) {
			this.paymentusService.fetchPaymentProfiles(token)
				.then((res) => {
					this.paymentProfiles = res.profiles === undefined || res.profiles === null ? [] : res.profiles;
					this.onPaymentMethodRefresh.emit(this.paymentProfiles);
					if (this.paymentProfiles && this.paymentProfiles.length > 0) {
						const hasDefaultPaymentMethod = this.paymentProfiles.find((profile) => profile.default);
						if (!hasDefaultPaymentMethod) {
							this.primaryPaymentProfile = this.paymentProfiles[0]
							this.primaryPaymentProfileId = 0;
						} else {
							this.primaryPaymentProfile = this.paymentProfiles.find((profile) => profile.default);
							this.primaryPaymentProfileId = this.paymentProfiles.indexOf(this.primaryPaymentProfile);
						}
					}

					this.isLoading = false;
				});

			if (this.isEnrollment) {
				this.isAddingNewPaymentMethod = true;
			}

			if (!this.isEnrollment) {
				this.dashboardService.getAccountDetail({ token })
					.then((response) => {
						const logObj = {
							method: this.constructor.name + '.getAccountDetail',
							request: 'token : [masked]',
							response
						};
						this.logger.logInfo(JSON.stringify(logObj));
						if (response.result.status === 'success') {
							this.currentAccountBalance = response.result.accountBalance;
						}
						this.isLoading = false;
					});
			}
		} else if (this.isExpressPay) {
			this.paymentusService.fetchPaymentProfilesForBan(this.billingAccountNumber)
				.then((res) => {
					this.paymentProfiles = res.profiles === undefined || res.profiles === null ? [] : res.profiles;
					this.onPaymentMethodRefresh.emit(this.paymentProfiles);
					if (this.paymentProfiles && this.paymentProfiles.length > 0) {
						const hasDefaultPaymentMethod = this.paymentProfiles.find((profile) => profile.default);
						if (!hasDefaultPaymentMethod) {
							this.primaryPaymentProfile = this.paymentProfiles[0]
							this.primaryPaymentProfileId = 0;
						} else {
							this.primaryPaymentProfile = this.paymentProfiles.find((profile) => profile.default);
							this.primaryPaymentProfileId = this.paymentProfiles.indexOf(this.primaryPaymentProfile);
						}
					}
					this.isLoading = false;
				});
		} else {
			this.isLoading = false;
		}
	}

	setPaymentAmount(paymentAmount: PaymentAmount, custom: boolean = false) {
		if (this.isSubmittingPayment) {
			return;
		}
		if (custom) {
			this.isSettingCustomPaymentAmount = true;
			this.currentPaymentAmount = 20;
		} else {
			this.currentPaymentAmount = Number(paymentAmount.amount);
			this.isSettingCustomPaymentAmount = false;
			this.validPaymentAmount = true;
		}
		this.onPaymentAmountChanged.emit(this.currentPaymentAmount);
	}

	addMoneyValid(add_money: any) {
		if (this.currentPaymentAmount
			&& this.currentPaymentAmount >= this.currentPaymentAmount
			&& this.currentPaymentAmount >= 1
			&& this.currentPaymentAmount <= 300) {
			this.validPaymentAmount = true;
			this.onPaymentAmountChanged.emit(this.currentPaymentAmount);
		} else {
			this.validPaymentAmount = false;
			if (this.currentPaymentAmount > 300) {
				this.currentPaymentAmount = 300;
			}
		}
	}

	cvvValid(event) {
		if (!this.cvv || !CVV_REGEX.test(this.cvv.toString())) {
			this.validCvv = false;
		} else {
			if (this.cvv.toString().length > 4) {
				this.cvv = this.cvv.toString().slice(0, 4);
			}
			this.validCvv = !(this.cvv.toString().length < 3 || this.cvv.toString().length > 4);
			this.onCvvUpdate.emit(this.cvv);
		}
	}

	calculateTotalPaymentAmount() {
		return this.hasProcessingCharge() ? this.currentPaymentAmount + this.processingFee : this.currentPaymentAmount;
	}

	hasProcessingCharge() {
		return this.isEnrollment ? false : this.currentPaymentAmount < MINIMUM_PAYMENT_WITHOUT_CHARGES;
	}

	refreshPaymentProfiles(res) {
		if (res && this.paymentProfiles.length !== res.length) {
			const newProfile = res.find((profile) => this.paymentProfiles.findIndex((oldProfile) => oldProfile.token === profile.token) === -1);
			if (newProfile) {
				this.primaryPaymentProfile = newProfile;
			}
			this.paymentProfiles = res.map((profile) => {
				const data = profile;
				if (data.type === 'VISA_DEBIT' || data.type === 'VISA_CREDIT') {
					data.type = 'visa';
				} else if (data.type === 'MC_DEBIT' || data.type === 'MC_CREDIT') {
					data.type = 'mastercard';
				} else if (data.type === 'AMEX') {
					data.type = 'americanexpress';
				} else if (data.type === 'DISC_DEBIT' || data.type === 'DISC_CREDIT') {
					data.type = 'discover';
				}
				return data;
			});
			if (this.isEnrollment) {
				this.primaryPaymentProfile = this.paymentProfiles.length > 0 ? this.paymentProfiles[0] : undefined;
				if (this.primaryPaymentProfile) {
					this.primaryPaymentProfileId = this.paymentProfiles.indexOf(this.primaryPaymentProfile);
				}
			}
			this.isAddingNewPaymentMethod = false;
		}

		this.onPaymentMethodRefresh.emit(res);
	}

	submitPayment() {
		this.isSubmittingPayment = true;
		let token: string = this.localStorageService.get('token');
		if (token === null) {
			token = this.localStorageService.get('tempToken');
		}

		const req = {
			token: this.isExpressPay ? this.billingAccountNumber : token,
			PaymentAmount: this.currentPaymentAmount,
			PaymentMethodToken: this.primaryPaymentProfile.token,
			SavePaymentMethod: this.savePaymentMethodToProfile,
			IsAutoPay: this.isAutoPay,
			IsEnrollment: this.isEnrollment,
			IsExpressPay: this.isExpressPay,
			Cvv: this.cvv,
			CardZipCode: this.primaryPaymentProfile.zip,
			IPAddress: this.ipAddress
		};

		this.paymentusService.paymentPay(req).then((res) => {
			const logObj = {
				method: this.constructor.name + '.paymentPay',
				request: {
					token: '[masked]',
					PaymentAmount: this.currentPaymentAmount,
					PaymentMethodToken: this.primaryPaymentProfile.token,
					SavePaymentMethod: this.savePaymentMethodToProfile,
					IsAutoPay: this.isAutoPay,
					IsEnrollment: this.isEnrollment,
					Cvv: this.cvv
				},
				response: res
			};
			this.logger.logInfo(JSON.stringify(logObj));
			if (res.result.status === 'success') {
				this.isPaymentSuccess = true;
			} else {
				this.isRetryPayment = false;
			}
			res.result.paymentProfile = this.primaryPaymentProfile;
			this.paymentReceipt = res.result;
			this.onPaymentStatusUpdate.emit(res.result.status === 'success');
			this.isSubmittingPayment = false;
		});
	}

	isCard(type: string) {
		return type.includes('CREDIT') || type.includes('DEBIT') || type.includes('MC') || type.includes('VISA') || type.includes('AMEX') || type.includes('DISC');
	}

	updateSavePaymentProfile(status) {
		this.onSavePaymentProfileUpdate.emit(status)
	}

	paymentProfile() {
		if (this.primaryPaymentProfile) {
			return this.primaryPaymentProfile;
		} else {
			const defaultMethod = this.paymentProfiles.find((profile) => profile.default)
			if (defaultMethod) {
				return defaultMethod;
			} else {
				return this.paymentProfiles.length > 0 ? this.paymentProfiles[0] : undefined;
			}
		}
	}
}

@Pipe({ name: 'safeStyle' })
export class SafeStylePipe implements PipeTransform {
	constructor(private sanitizer: DomSanitizer) {
	}

	transform(value) {
		return this.sanitizer.bypassSecurityTrustStyle(value);
	}
}



// WEBPACK FOOTER //
// ./src/app/payment/paymentus/make-payment/submit-payment.component.ts